import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormControl from "react-bootstrap/FormControl";
import FormLabel from "react-bootstrap/FormLabel";
import styled from "styled-components";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";

const StyledLogin = styled.section`
  & {
    padding: 2rem 0 5rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & .form-check-input {
    border-color: black !important;
  }
  & .form-check-label {
    font-weight: 500;
  }
  & .remember {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
  }
`;

export default function Login({ setLoggedIn, setSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const onSubmit = async (e) => {
    setSuccess(false);
    setError(false);
    setLoading(true);
    e.preventDefault();
    if (username && password) {
      try {
        const res = await axios.post(
          process.env.REACT_APP_LOGIN,
          {
            username,
            password,
          },
          { headers: { "Content-Type": "application/json" } }
        );
        if (res?.data?.token && res?.data?.userId !== "SMLS") {
          setSuccess(true);
          sessionStorage.setItem("loggedIn", true);

          setTimeout(() => setSuccess(false), 1000);
          setTimeout(() => setLoggedIn(true), 500);
        }
      } catch (err) {
        console.log(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <StyledLogin>
      <Container>
        <Row className="d-flex justify-content-center  mx-3 mx-sm-0">
          <Col
            style={{ background: "white", borderRadius: "10px" }}
            sm={8}
            md={6}
            lg={4}
          >
            <FormLabel className="w-100 text-start mt-2">
              <strong>Username</strong>
            </FormLabel>
            <FormControl
              onChange={(e) => setUsername(e.target.value)}
              type="text"
              placeholder="Enter your username"
              className="p-3"
            />

            <FormLabel className="w-100 text-start mt-3">
              <strong>Password</strong>
            </FormLabel>
            <FormControl
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="Enter your password"
              className=" p-3"
            />

            {error ? (
              <FormLabel style={{ color: "red" }} className="w-100 text-center">
                <strong>Login Failed</strong>
              </FormLabel>
            ) : null}

            <Button
              disabled={loading}
              onClick={onSubmit}
              className="w-100 my-4"
            >
              {loading ? (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              ) : (
                "Login"
              )}
            </Button>
          </Col>
        </Row>
      </Container>
    </StyledLogin>
  );
}
